/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpigreq23Inputs */

const en_crosspostinghelpigreq23 = /** @type {(inputs: Crosspostinghelpigreq23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Instagram account must be linked to a Facebook Page. Link it: Facebook Page → Settings → Linked accounts → Instagram.`)
};

const de_crosspostinghelpigreq23 = /** @type {(inputs: Crosspostinghelpigreq23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Instagram-Konto muss mit einer Facebook-Seite verknüpft sein. Verknüpfen: Facebook-Seite → Einstellungen → Verknüpfte Konten → Instagram.`)
};

/**
* | output |
* | --- |
* | "The Instagram account must be linked to a Facebook Page. Link it: Facebook Page → Settings → Linked accounts → Instagram." |
*
* @param {Crosspostinghelpigreq23Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpigreq23 = /** @type {((inputs?: Crosspostinghelpigreq23Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpigreq23Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpigreq23(inputs)
	return de_crosspostinghelpigreq23(inputs)
});
export { crosspostinghelpigreq23 as "crosspostingHelpIgReq2" }